
const defaultSetings = require('./env.' + (process.env?.ENVM || process.env?.localenv.ENVM))
module.exports = defaultSetings